module.exports = __webpack_public_path__ + "img/pickThree_w.fa0f889e.png";